import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";

// reactstrap components
import { Card, CardBody, Row, Col, Container } from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";

// services
import { showMessage } from "services/message.js";
import { api_GET, api_POST } from "services/api_service.js";

// views
import Identificacao from "../../../views/Shared/Destino/Identificacao";
import Locais from "../../../views/Shared/Destino/Locais";
import Documentos from "../../../views/Shared/Documentos";
import Declaracao from "../../../views/Shared/Declaracao";

//Context
import { useAuth } from '../../../context/auth';

export default function DestinoRequerimentoRenovacaoCadastro({ history }) {
    const {session, setLoading, setupSistema} = useAuth();

    const location = useLocation();

    const [requerimento, set_requerimento] = React.useState(null);
    const [opcao, set_opcao] = React.useState(null);

    const [step, set_step] = React.useState(0);
    const handleProximoStep = (_requerimento) => {
        if ((step == 3 && opcao.categoria.sigla != "RGG") || (step == 2 && opcao.categoria.sigla == "RGG")) {
            history.push("opcoes");
        }
        else {
            set_requerimento(_requerimento);
            set_step(step + 1);
        }
    }
    const handleStepAnterior = (_requerimento) => {
        set_requerimento(_requerimento)
        set_step(step - 1);
    }

    const loadRequerimento = () => {
        if (location.state.requerimento == null) {
            setLoading(true);
            let json_submit = {
                protocolo_Id: location.state.protocolo.protocolo_Id,
                requerimento_Id: 0,
                nomeSolicitante: location.state.protocolo.nomeSolicitante,
                email: location.state.protocolo.email,
                cpf_Cnpj: location.state.protocolo.cpf_Cnpj,
                setupSolicitacaoAcao_Id: location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id,
            }

            api_POST('requerimento/PostRequerimento ', json_submit).then(result => {
                set_opcao({
                    tipoCadastro: "Requerimento",
                    segmento: "Destino Final",
                    categoria: result.data.setupSolicitacaoAcao.setupSolicitacao.categoria
                });
                set_requerimento(result.data);
                set_step(0);
            })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
        else {
            api_GET('requerimento/' + location.state.requerimento.requerimento_Id).then(result => {
                set_opcao({
                    tipoCadastro: "Requerimento",
                    segmento: "Destino Final",
                    categoria: result.data.setupSolicitacaoAcao.setupSolicitacao.categoria
                });;
                set_requerimento(result.data);
                set_step(0);
            })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }

    useEffect(() => {
        loadRequerimento();
    }, []);

    const steps = [];

    if (opcao != null) {
        if (opcao.categoria.sigla != "RGG")
            steps.push('Identificação', 'Locais de Destinação', 'Documentação');
        else
            steps.push('Identificação', 'Documentação');
    }

    return (
        <>
            {requerimento != null && opcao != null && ((step < 3 && opcao.categoria.sigla == "RGG") || (step < 4 && opcao.categoria.sigla != "RGG")) &&
                <div className="content">
                    <Container className="text-center">
                        <ProgressBar stepValue={step} steps={steps} />
                    </Container>
                    {requerimento.status == "Divergente" && requerimento.requerimentoAnaliseGestor.length > 0 &&
                        <Card className="card-stats">
                            <CardBody>
                                <h5 className="text-danger">Seu requerimento foi rejeitado por {setupSistema?.identificacao}. Verifique as informações abaixo e corrija os dados necessários.</h5>
                                <p>{requerimento.requerimentoAnaliseGestor.sort(function (a, b) { return new Date(b.dataAnalise) - new Date(a.dataAnalise); })[0].observacao}</p>
                            </CardBody>
                        </Card>
                    }

                    {step == 0 && <Identificacao item={requerimento} tipoCadastro="Requerimento" handleProximoStep={handleProximoStep}></Identificacao>}
                    {opcao.categoria.sigla != "RGG" ? step == 1 && <Locais item={requerimento} tipoCadastro="Requerimento" handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></Locais> : ""}
                    {opcao.categoria.sigla != "RGG" ?
                        step == 2 && <Documentos item={requerimento} opcao={opcao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></Documentos>
                        :
                        step == 1 && <Documentos item={requerimento} opcao={opcao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></Documentos>
                    }
                    {opcao.categoria.sigla != "RGG" ?
                        step == 3 && <Declaracao item={requerimento} handleFinalizarCadastro={handleProximoStep} handleStepAnterior={handleStepAnterior}></Declaracao>
                        :
                        step == 2 && <Declaracao item={requerimento} handleFinalizarCadastro={handleProximoStep} handleStepAnterior={handleStepAnterior}></Declaracao>
                    }
                </div>
            }

            {requerimento != null && opcao != null && (step == 4 || (opcao.categoria.sigla == "RGG" && step == 3)) &&
                <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                    <div className="formPrincipal">
                        <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, .5)", paddingBottom: "10px", paddingTop: "10px" }}>
                            <Col md="12">
                                <span className={`${session && session.tipoAcesso == "AreaRestrita" ? "text-white" : "text-black"}`}>Este requerimento já foi finalizado. Para visualizar e acompanhar as informações do requerimento, acesse o menu "Meu Cadastro".</span>
                            </Col>
                        </Row>
                    </div>
                </Container>
            }
        </>
    );
}